// extracted by mini-css-extract-plugin
export default {"container":"OzqX_eGo","skeleton":"PfFtc7S8"};